import { Button, Col, Divider, Flex, Modal, Row, Space } from "antd";
import cx from "classnames";
import { FieldArray, Form, Formik } from "formik";
import React from "react";

import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Input } from "components/form";

import schema from "features/company/schemas/companyModalLevelSchema";
import styles from "./Modal.module.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function ModalLevel({
  title = "",
  width = 900,
  className = "",
  back = "CANCEL",
  submit = "SAVE",
  isModalOpen = false,
  organizationLevelOption = [],
  onSubmit = () => { },
  handleOk = () => { },
  handleCancel = () => { },
}) {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const hasAccess = roles.includes("ACCESS_CONFIGURATION|COMPANY_SETTING|ORGANIZATION");
  const canEdit = roles.includes("CREATE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION") || roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION");
  const canDelete = roles.includes("DELETE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION")
  const isView = hasAccess && !canEdit && !canDelete;

  return (
    <Modal
      title={title}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className={cx(styles.customStyle, className)}
      width={width}
      footer={null}
      maskClosable={false}
      closable={false}
      destroyOnClose
    >
      <Formik
        enableReinitialize
        initialValues={{
          Information: false,
          organization: organizationLevelOption,
        }}
        validationSchema={schema}
        onSubmit={onSubmit}
      >
        {({ values = {} }) => {
          return (
            <Form>
              <Space
                className={styles.container}
                size={24}
                direction="vertical"
              >
                <Divider />
                <Row style={{ rowGap: "16px", paddingBottom: "16px" }}>
                  <FieldArray
                    name="organization"
                    render={(arrayHelpers) =>
                      values.organization.map((_, index) => (
                        <React.Fragment key={index}>

                          <Col span={12} style={{ paddingRight: "0.5vw" }}>
                            <Input
                              name={`organization[${index}].organizationLevelName`}
                              label={`${t("organization_level.label.level")} ${index + 1
                                } (${t("organization_level.label.th")})`}
                              placeholder={`${t(
                                "organization_level.label.level"
                              )} ${index + 1} (${t(
                                "organization_level.label.th"
                              )})`}
                              size="large"
                              disabled={isView}
                            />
                          </Col>
                          <Col span={isView ? 11 : 10} style={{ paddingLeft: "0.5vw" }}>
                            <Input
                              name={`organization[${index}].organizationLevelNameEn`}
                              label={`${t("organization_level.label.level")} ${index + 1
                                } (${t("organization_level.label.en")})`}
                              placeholder={`${t(
                                "organization_level.label.level"
                              )} ${index + 1} (${t(
                                "organization_level.label.en"
                              )})`}
                              size="large"
                              disabled={isView}
                            />
                          </Col>
                          <Flex vertical
                            style={{ display: "flex", alignSelf: "end", marginLeft: "2vw" }}
                          >
                            <Col>
                              {canEdit &&
                                values.organization.length - 1 === index &&
                                index !== 9 && (
                                  <PlusCircleOutlined
                                    className={styles.miniplusBtn}
                                    onClick={() => {
                                      arrayHelpers.insert(index + 1, {
                                        organizationLevelName: null,
                                        organizationLevelNameEn: null,
                                        organizationLevelId: null,
                                        level: `${index + 2}`,
                                      });
                                    }}
                                  />
                                )}
                            </Col>
                            <Col>
                              {canEdit && index > 1 && (
                                <MinusCircleOutlined
                                  className={styles.miniMinusBtn}
                                  onClick={() => arrayHelpers.remove(index)}
                                />
                              )}
                            </Col>
                          </Flex>
                        </React.Fragment>
                      ))
                    }
                  />
                </Row>

                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button
                      key="back"
                      onClick={handleCancel}
                      type="default"
                      style={{ height: "40px", borderRadius: "8px" }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    {canEdit &&
                      <Button
                        htmlType="submit"
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                      >
                        {t("common.submit").toUpperCase()}
                      </Button>
                    }
                  </Space>
                </Row>

              </Space>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default ModalLevel;
